import {RotationOrientationType} from "@Features/icons/types/RotationOrientationType";

export default function setOrientationArrowAirplane(orientation: RotationOrientationType) {
    const rotate = {
        [`${orientation === "left"}`]: "-180deg",
        [`${orientation === "right"}`]: "0deg",
        [`${orientation === "up"}`]: "-90deg",
        [`${orientation === "down"}`]: "90deg",
    }

    return rotate.true ? {transform: `rotate(${rotate.true})`} : {};
}